import React from "react";

const PasswordModifyIcon = ({
  color = "#2B363B",
  width = 18,
  height = 18,
  opacity = 0.75,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Icono modificar contraseña"
    {...props}
  >
    <path
      d="M10.0002 14.1666C9.55814 14.1666 9.13421 13.991 8.82165 13.6784C8.50909 13.3659 8.3335 12.9419 8.3335 12.4999C8.3335 11.5749 9.07516 10.8333 10.0002 10.8333C10.4422 10.8333 10.8661 11.0088 11.1787 11.3214C11.4912 11.634 11.6668 12.0579 11.6668 12.4999C11.6668 12.9419 11.4912 13.3659 11.1787 13.6784C10.8661 13.991 10.4422 14.1666 10.0002 14.1666ZM15.0002 16.6666V8.33325H5.00016V16.6666H15.0002ZM15.0002 6.66658C15.4422 6.66658 15.8661 6.84218 16.1787 7.15474C16.4912 7.4673 16.6668 7.89122 16.6668 8.33325V16.6666C16.6668 17.1086 16.4912 17.5325 16.1787 17.8451C15.8661 18.1577 15.4422 18.3333 15.0002 18.3333H5.00016C4.55814 18.3333 4.13421 18.1577 3.82165 17.8451C3.50909 17.5325 3.3335 17.1086 3.3335 16.6666V8.33325C3.3335 7.40825 4.07516 6.66658 5.00016 6.66658H5.8335V4.99992C5.8335 3.89485 6.27248 2.83504 7.05388 2.05364C7.83529 1.27224 8.89509 0.833252 10.0002 0.833252C10.5473 0.833252 11.0892 0.941026 11.5947 1.15042C12.1002 1.35982 12.5595 1.66673 12.9464 2.05364C13.3334 2.44055 13.6403 2.89988 13.8497 3.4054C14.0591 3.91093 14.1668 4.45274 14.1668 4.99992V6.66658H15.0002ZM10.0002 2.49992C9.33712 2.49992 8.70124 2.76331 8.2324 3.23215C7.76355 3.70099 7.50016 4.33688 7.50016 4.99992V6.66658H12.5002V4.99992C12.5002 4.33688 12.2368 3.70099 11.7679 3.23215C11.2991 2.76331 10.6632 2.49992 10.0002 2.49992Z"
      fill={color}
      fillOpacity={opacity}
    />
  </svg>
);

export default PasswordModifyIcon;
